export const EDITION_SECTION_TYPES = Object.freeze({
  HERO: 'edition-hero',
  CATEGORIES: 'edition-category-mosaic',
  PRODUCTS: 'edition-product-edit',
  STORY: 'edition-story',
});

export const EDITION_SECTION_META = Object.freeze([
  { type: EDITION_SECTION_TYPES.HERO, name: 'Edition hero', icon: 'layout', description: 'Editorial campaign image, headline and action' },
  { type: EDITION_SECTION_TYPES.CATEGORIES, name: 'Collection mosaic', icon: 'grid', description: 'Your product categories in an editorial mosaic' },
  { type: EDITION_SECTION_TYPES.PRODUCTS, name: 'Product edit', icon: 'grid', description: 'A curated rail of products from your catalogue' },
  { type: EDITION_SECTION_TYPES.STORY, name: 'The Edit', icon: 'quote', description: 'Closing brand-story panel and link' },
]);

export function createEditionSections() {
  return [
    {
      id: 'edition-hero-1', type: EDITION_SECTION_TYPES.HERO,
      content: { eyebrow: 'New collection', title: '', body: '', buttonText: 'Shop the collection', buttonLink: '/shop', image: '' },
      settings: { overlay: 'dark', minHeight: '760px', contentPosition: 'left', imagePosition: 'center', overlayOpacity: 0.45 },
    },
    {
      id: 'edition-categories-1', type: EDITION_SECTION_TYPES.CATEGORIES,
      content: { eyebrow: 'Explore', title: 'Shop by mood' }, settings: { maxCategories: 3, spacing: 'standard' },
    },
    {
      id: 'edition-products-1', type: EDITION_SECTION_TYPES.PRODUCTS,
      content: { eyebrow: 'Selected pieces', title: 'Worth keeping close.', linkText: 'View all', link: '/shop' }, settings: { count: 8, spacing: 'standard' },
    },
    {
      id: 'edition-story-1', type: EDITION_SECTION_TYPES.STORY,
      content: { eyebrow: 'The edit', title: '', body: 'Explore considered pieces, save your favourites and check out securely when you are ready.', linkText: 'About the store', link: '/about' }, settings: { spacing: 'standard' },
    },
  ];
}

export function isEditionSection(section) {
  return EDITION_SECTION_META.some((item) => item.type === section?.type);
}
